<template>
  <div>
    <label for="phone_number" class="block text-sm font-medium text-gray-700"
      >{{ label }} <span v-if="optional" class="text-xs text-gray-700">(optional)</span></label
    >
    <div
      class="mt-1 flex rounded-md border border-gray-300 bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500"
    >
      <select
        id="country"
        v-model="country"
        name="country"
        class="bg-white border-0 rounded-l-md focus:ring-0 focus:border-0 px-3 py-2 min-h-[38px] text-gray-700 sm:text-sm"
      >
        <option>US</option>
      </select>
      <input
        id="phone_number"
        v-model="textValue"
        :disabled="disabled"
        type="tel"
        :class="[
          'bg-white border-0 rounded-r-md focus:ring-0 focus:border-0 px-3 py-2 min-h-[38px] text-gray-700 sm:text-sm flex-1',
          showValidation ? 'text-red-900 placeholder-red-300' : '',
        ]"
        :placeholder="placeholder"
        autocomplete="off"
        @input="
          validatePhoneNumber($event);
          $emit('update:modelValue', $event.target.value);
        "
      />
    </div>
    <div v-if="showValidation" class="mt-1 text-sm text-red-600">Please enter a valid phone number.</div>
  </div>
</template>

<script>
import PhoneUtility from '../../utilities/phone.js';

export default {
  props: ['modelValue', 'label', 'placeholder', 'optional', 'disabled'],
  data() {
    return {
      textValue: this.modelValue,
      showValidation: false,
      country: 'US',
    };
  },
  watch: {
    modelValue(newVal) {
      this.textValue = newVal;
    },
  },
  methods: {
    validatePhoneNumber(e) {
      PhoneUtility.isValidNumber(e.target.value, this.country)
        ? (this.showValidation = false)
        : (this.showValidation = true);
    },
  },
};
</script>
